import { useContext } from 'react';

import { PathwayProviderContext } from './PathwayProvider';

export const usePathwayId = () => {
  const pathwayContext = useContext(PathwayProviderContext);
  return pathwayContext?.pathwayId || null;
};
